import { createFileRoute } from '@tanstack/react-router';
import { ConnectorBuilderPage } from '@/components/connectors/connector-builder';

export const Route = createFileRoute('/_dashboard/connectors/$connectorId')({
  component: EditConnectorPage,
});

function EditConnectorPage() {
  return <ConnectorBuilderPage />;
}
